export default {
  legalEntities: {},
  legalEntity: undefined,

  associates: [],
  admins: []
}
